import {h, Fragment} from "preact"
// import { translatedText } from "./utils/translatedText";

// export default function ProductColorCountBadge({product}) {
//     const customFields = product.customFields || [];

//     const getFieldKey = (field) => (customFields.find((f) => f.key === field)?.value || "");
//     const colorVarinatsList = getFieldKey("custom-color_variants");
//     const colorVariants = JSON.parse(colorVarinatsList);
//     const colorVariantsCount = colorVariants.length;

//     if(colorVariantsCount> 1){
//       return (
//         <span class="text-13-115--0.5-400 text-grey">
//           {colorVariantsCount} {translatedText("colors")}
//         </span>
//       );
//     }else{
//       null
//     }

//   }
import { translatedText } from "./utils/translatedText";

export default function ProductColorCountBadge({ product }) {
  const customFields = product?.customFields || [];

  const getFieldKey = (field) =>
    customFields.find((f) => f.key === field)?.value || "";

  const colorVariantsRaw = getFieldKey("custom-color_variants");

  // Safely parse the JSON string
  let colorVariants = [];
  try {
    if (colorVariantsRaw && colorVariantsRaw !== "null" && colorVariantsRaw !== "undefined") {
      const parsed = JSON.parse(colorVariantsRaw);
      if (Array.isArray(parsed)) {
        colorVariants = parsed;
      }
    }
  } catch {
    colorVariants = [];
  }

  const colorVariantsCount = colorVariants.length;

  if (colorVariantsCount > 1) {
    return (
      <span class="text-13-115--0.5-400 text-grey">
        {colorVariantsCount} {translatedText("colors")}
      </span>
    );
  }

  return null;
}
